import type { NotificationsPort } from '../domain/notification'

const makeDismissNotification = (port: NotificationsPort) => (id: string) => {
	port.dismiss(id)
}

export { makeDismissNotification }
